"use client"

import type React from "react"
import type { SyncStatusType } from "../../../types/sync-progress"

interface ActionButtonsProps {
  status: SyncStatusType
  onGoToHome: () => void
  onViewLogs: () => void
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ status, onGoToHome, onViewLogs }) => {
  if (status === "completed") {
    return (
      <div className="completed-actions">
        {/* <button className="secondary-button" onClick={onViewLogs}>
          View Sync Logs
        </button> */}
        <button className="primary-button" onClick={onGoToHome}>
          Go to Dashboard
        </button>
      </div>
    )
  }

  return (
    <div className="syncing-actions-disabled">
      <button className="primary-button" disabled>
        Saving Setting... Please wait
      </button>
    </div>
  )
}

export default ActionButtons
